import { styled, spacing, mq } from '@thg-commerce/enterprise-theme'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { SocialShareRenderer } from '@thg-commerce/enterprise-core'

export const StyledParagraph = styled.p`
  padding-top: ${spacing(2)};
  text-align: left;
`

export const StyledGrid = styled(Grid)`
  border-bottom: ${(props) => props.theme.colors.palette.greys.light} 1px solid;
  padding-bottom: ${spacing(2)};
  margin: 0px;
`

export const SocialsGridItem = styled(GridItem)`
  margin-bottom: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${spacing(2)};
  }
`

export const StyledSocialShareRenderer = styled(SocialShareRenderer)`
  height: 40px;
  align-self: center;
`

export const FooterSocialShareGridItem = styled(GridItem)`
  margin-top: ${spacing(5)};
  text-align: center;
`

export const AuthorInformationGridItem = styled(GridItem)`
  margin-top: ${spacing(5)};
  margin-bottom: ${spacing(2)};
`

export const RelatedArticlesGridItem = styled(GridItem)`
  margin: ${spacing(8)} 0 0 0;
`

export const GlobalLinkCardsGridItem = styled(GridItem)`
  margin: ${spacing(8)} 0 0 0;
`

export const ReferencesGridItem = styled(GridItem)`
  margin-top: ${spacing(5)};
`

export const ArticleBodyGridItem = styled(GridItem)`
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
`
